var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "table-layout" },
      [
        _c(
          "el-table",
          {
            ref: "staffList",
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.staffList,
              border: "",
              "tooltip-effect": "dark"
            },
            on: { "selection-change": _vm.handleSelectionChange }
          },
          [
            _c("el-table-column", {
              attrs: {
                type: "selection",
                align: "center",
                selectable: _vm.isDisable,
                width: "55"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "center",
                width: "130",
                prop: "no",
                label: "员工编号"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "left",
                width: "130",
                prop: "name",
                label: "员工姓名"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "center",
                width: "130",
                prop: "contactTel",
                label: "联系电话"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "center",
                width: "130",
                prop: "enrollDate",
                label: "入职日期"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "center",
                width: "130",
                prop: "contactEmail",
                label: "电子邮箱"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { align: "center", prop: "osFlag", label: "是否外协" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      rows.row.osFlag
                        ? _c("span", { staticClass: "font-green" }, [
                            _vm._v("是")
                          ])
                        : _vm._e()
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("span", { staticClass: "inline-block" }, [_vm._v("已选择的收信人")]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "enum-list inline-block" },
        _vm._l(_vm.staffCheckList, function(staff) {
          return _c("li", { staticClass: "enum-item checked" }, [
            _c("span", [_vm._v(_vm._s(staff.name))]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "delete",
                on: {
                  click: function($event) {
                    _vm.remove(staff.id)
                  }
                }
              },
              [_vm._v("×")]
            )
          ])
        })
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7fb71d9a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fb71d9a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/orgStruct/ComStaffListForMsg.vue
// module id = 3300
// module chunks = 0